import { combineReducers } from 'redux';

import extFilterApiReducer, { IExtFilterApiInitialState } from './extFilterApiReducer';
import extFilterConstructorReducer, { IExtFilterConstructorInitialState } from './extFilterConstructorReducer';

/**
 * @description External filter state
 * @interface IExtFilterReducer
 * @property {IExtFilterApiInitialState} api - extrenal filter api state
 * @property {IExtFilterConstructorInitialState} constructor - extrenal filter constructor state
 */
export interface IExtFilterReducer {
    api: IExtFilterApiInitialState;
    filterConstructor: IExtFilterConstructorInitialState;
}

export const extFilterReducer = () => combineReducers({
    api: extFilterApiReducer,
    filterConstructor: extFilterConstructorReducer,
});
